module.exports = __webpack_public_path__ + "static/media/10.d2a26079.webp";